<div class="modal-overlay" (click)="onCancel()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <button type="button" class="close-btn" (click)="onCancel()" aria-label="Close">
      <i class="fas fa-times"></i>
    </button>

    <div class="modal-header">
      <h2>{{ t('offlinePurchaseModalTitle') }}</h2>
      <p class="modal-subtitle">{{ t('offlinePurchaseModalSubtitle') }}</p>
    </div>

    <div class="modal-body">
      <ng-container *ngIf="step === 'select'">
        <div class="dose-list">
          <div *ngFor="let d of doseOptions" class="dose-row" [class.disabled]="isDisabled(d.doseNumber)" [class.selected]="selected[d.doseType]">
            <label class="dose-label">
              <input
                type="checkbox"
                [checked]="selected[d.doseType]"
                [disabled]="isDisabled(d.doseNumber)"
                (change)="toggleDose(d.doseType, d.doseNumber)">
              <span class="dose-name" [class.dose-green]="d.doseType === 'green'" [class.dose-yellow]="d.doseType === 'yellow'" [class.dose-red]="d.doseType === 'red'">{{ getDoseLabel(d.doseType) }}</span>
            </label>
            <div *ngIf="selected[d.doseType]" class="date-field">
              <label [for]="'date-' + d.doseType">{{ t('offlinePurchaseDateLabel') }}</label>
              <input
                [id]="'date-' + d.doseType"
                type="date"
                [max]="today"
                [(ngModel)]="purchaseDates[d.doseType]"
                (ngModelChange)="onDateChange()">
            </div>
          </div>
        </div>
        <p *ngIf="!allDatesFilled() && (selected['green'] || selected['yellow'] || selected['red'])" class="hint">{{ t('offlinePurchaseDateHint') }}</p>
        <p *ngIf="sequenceError()" class="hint hint-error">
          <i class="fas fa-exclamation-circle"></i> {{ sequenceError() }}
        </p>
      </ng-container>

      <ng-container *ngIf="step === 'confirm'">
        <div class="confirm-summary">
          <p class="confirm-intro">{{ t('offlinePurchaseConfirmIntro') }}</p>
          <ul>
            <li *ngFor="let e of getSelectedWithDates()">
              <strong>{{ getDoseLabel(e.doseType) }}</strong> – {{ formatDateForSummary(e.purchaseDate) }}
            </li>
          </ul>
        </div>
      </ng-container>
    </div>

    <div class="modal-footer">
      <ng-container *ngIf="step === 'select'">
        <button type="button" class="btn-secondary" (click)="onCancel()">{{ t('cancel') }}</button>
        <button type="button" class="btn-primary" [disabled]="!canProceedToConfirm()" (click)="goToConfirm()">{{ t('offlinePurchaseNext') }}</button>
      </ng-container>
      <ng-container *ngIf="step === 'confirm'">
        <button type="button" class="btn-secondary" (click)="backToSelect()">{{ t('back') }}</button>
        <button type="button" class="btn-primary" [disabled]="!datesInSequence()" (click)="onConfirm()">{{ t('offlinePurchaseConfirm') }}</button>
      </ng-container>
    </div>
  </div>
</div>
